module.exports = __webpack_public_path__ + "img/0Q3A5108-23_P_L_BlackMatted.a3b2d48e.jpg";